import React from "react";
import { useTranslation } from "react-i18next";
import { Badge, Box, Button, Card, Grid, Icon, Modal, Text } from "~/components-shared";
import styled from "styled-components";
import { RoutesEnum } from "~/types/enums";
const StyledIcon = styled(Icon)`
  box-shadow: inset 0 0 0 6px ${_ref => {
  let {
    theme
  } = _ref;
  return theme.colors.success.main;
}};
  border-radius: 50%;
`;
const SetupGuideModal = _ref2 => {
  let {
    onClose,
    setupGuide
  } = _ref2;
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/React.createElement(Modal.Body, {
    onClose: onClose,
    title: t("SetupGuideModal.setupGuide"),
    maxWidth: "600px",
    fullWidth: true
  }, /*#__PURE__*/React.createElement(Modal.Content, null, /*#__PURE__*/React.createElement(Box, {
    gap: 3,
    fullWidth: true
  }, (setupGuide.connectedIntegrations !== undefined || setupGuide.addedSlackChannels !== undefined || setupGuide.slackProfileConnected !== undefined || setupGuide.addedJiraProjects !== undefined || setupGuide.addedConfluenceSpaces !== undefined || setupGuide.addedLinearTeams !== undefined || setupGuide.addedAsanaProjects !== undefined || setupGuide.addedGithubRepositories !== undefined || setupGuide.addedMondayBoards !== undefined || setupGuide.addedProductboardProducts !== undefined) && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Text, {
    color: "primary",
    fontSize: 4,
    weight: "semiBold",
    s: {
      my: 2
    }
  }, /*#__PURE__*/React.createElement(Icon, {
    src: "webhook",
    s: {
      mr: 2
    }
  }), t("SetupGuideModal.integrations")), setupGuide.connectedIntegrations !== undefined && /*#__PURE__*/React.createElement(Card, {
    s: {
      px: 6
    },
    onClick: () => window.open(`${RoutesEnum.INTEGRATIONS}`),
    color: "translucent",
    fullWidth: true
  }, /*#__PURE__*/React.createElement(Grid, {
    cols: 3,
    template: "1fr auto",
    align: "center",
    gap: 3
  }, /*#__PURE__*/React.createElement(Grid.Cell, null, /*#__PURE__*/React.createElement(Text, {
    element: "h3",
    s: {
      mr: 2
    }
  }, t("SetupGuideModal.connectIntegrations"), !setupGuide.connectedIntegrations && /*#__PURE__*/React.createElement(Text, {
    color: "textSecondary",
    fontSize: 3.5,
    s: {
      ml: 2
    },
    weight: "semiBold"
  }, t("SetupGuideModal.connectIntegrationsTime"))), !setupGuide.connectedIntegrations && /*#__PURE__*/React.createElement(Text, {
    color: "textSecondary"
  }, t("SetupGuideModal.connectIntegrationsInfo"))), setupGuide.connectedIntegrations ? /*#__PURE__*/React.createElement(StyledIcon, {
    src: "checkboxFill",
    color: "success",
    scale: 6
  }) : /*#__PURE__*/React.createElement(Icon, {
    src: "arrow",
    color: "textSecondary",
    scale: 6
  }))), setupGuide.slackProfileConnected !== undefined && /*#__PURE__*/React.createElement(Card, {
    s: {
      px: 6
    },
    onClick: () => window.open(`${RoutesEnum.PROFILE}`),
    color: "translucent",
    fullWidth: true
  }, /*#__PURE__*/React.createElement(Grid, {
    cols: 3,
    template: "1fr auto",
    align: "center",
    gap: 3
  }, /*#__PURE__*/React.createElement(Grid.Cell, null, /*#__PURE__*/React.createElement(Text, {
    element: "h3",
    s: {
      mr: 2
    }
  }, t("SetupGuideModal.connectSlackProfile"), !setupGuide.slackProfileConnected && /*#__PURE__*/React.createElement(Text, {
    color: "textSecondary",
    fontSize: 3.5,
    s: {
      ml: 2
    },
    weight: "semiBold"
  }, t("SetupGuideModal.connectSlackProfileTime"))), !setupGuide.slackProfileConnected && /*#__PURE__*/React.createElement(Text, {
    color: "textSecondary"
  }, t("SetupGuideModal.connectSlackProfileInfo"))), setupGuide.slackProfileConnected ? /*#__PURE__*/React.createElement(StyledIcon, {
    src: "checkboxFill",
    color: "success",
    scale: 6
  }) : /*#__PURE__*/React.createElement(Icon, {
    src: "arrow",
    color: "textSecondary",
    scale: 6
  }))), setupGuide.addedSlackChannels !== undefined && /*#__PURE__*/React.createElement(Card, {
    s: {
      px: 6
    },
    onClick: () => window.open(`${RoutesEnum.INTEGRATIONS}`),
    color: "translucent",
    fullWidth: true
  }, /*#__PURE__*/React.createElement(Grid, {
    cols: 3,
    template: "1fr auto",
    align: "center",
    gap: 3
  }, /*#__PURE__*/React.createElement(Grid.Cell, null, /*#__PURE__*/React.createElement(Text, {
    element: "h3",
    s: {
      mr: 2
    }
  }, t("SetupGuideModal.slackChannels"), !setupGuide.addedSlackChannels && /*#__PURE__*/React.createElement(Text, {
    color: "textSecondary",
    fontSize: 3.5,
    s: {
      ml: 2
    },
    weight: "semiBold"
  }, t("SetupGuideModal.slackChannelsTime"))), !setupGuide.addedSlackChannels && /*#__PURE__*/React.createElement(Text, {
    color: "textSecondary"
  }, t("SetupGuideModal.slackChannelsInfo"))), setupGuide.addedSlackChannels ? /*#__PURE__*/React.createElement(StyledIcon, {
    src: "checkboxFill",
    color: "success",
    scale: 6
  }) : /*#__PURE__*/React.createElement(Icon, {
    src: "arrow",
    color: "textSecondary",
    scale: 6
  }))), setupGuide.addedJiraProjects !== undefined && /*#__PURE__*/React.createElement(Card, {
    s: {
      px: 6
    },
    onClick: () => window.open(`${RoutesEnum.INTEGRATIONS}`),
    color: "translucent",
    fullWidth: true
  }, /*#__PURE__*/React.createElement(Grid, {
    cols: 3,
    template: "1fr auto",
    align: "center",
    gap: 3
  }, /*#__PURE__*/React.createElement(Grid.Cell, null, /*#__PURE__*/React.createElement(Text, {
    element: "h3",
    s: {
      mr: 2
    }
  }, t("SetupGuideModal.jiraProjects"), !setupGuide.addedJiraProjects && /*#__PURE__*/React.createElement(Text, {
    color: "textSecondary",
    fontSize: 3.5,
    s: {
      ml: 2
    },
    weight: "semiBold"
  }, t("SetupGuideModal.jiraProjectsTime"))), !setupGuide.addedJiraProjects && /*#__PURE__*/React.createElement(Text, {
    color: "textSecondary"
  }, t("SetupGuideModal.jiraProjectsInfo"), "projects")), setupGuide.addedJiraProjects ? /*#__PURE__*/React.createElement(StyledIcon, {
    src: "checkboxFill",
    color: "success",
    scale: 6
  }) : /*#__PURE__*/React.createElement(Icon, {
    src: "arrow",
    color: "textSecondary",
    scale: 6
  }))), setupGuide.addedConfluenceSpaces !== undefined && /*#__PURE__*/React.createElement(Card, {
    s: {
      px: 6
    },
    onClick: () => window.open(`${RoutesEnum.INTEGRATIONS}`),
    color: "translucent",
    fullWidth: true
  }, /*#__PURE__*/React.createElement(Grid, {
    cols: 3,
    template: "1fr auto",
    align: "center",
    gap: 3
  }, /*#__PURE__*/React.createElement(Grid.Cell, null, /*#__PURE__*/React.createElement(Text, {
    element: "h3",
    s: {
      mr: 2
    }
  }, t("SetupGuideModal.confluenceSpaces"), !setupGuide.addedConfluenceSpaces && /*#__PURE__*/React.createElement(Text, {
    color: "textSecondary",
    fontSize: 3.5,
    s: {
      ml: 2
    },
    weight: "semiBold"
  }, t("SetupGuideModal.confluenceSpacesTime"))), !setupGuide.addedConfluenceSpaces && /*#__PURE__*/React.createElement(Text, {
    color: "textSecondary"
  }, t("SetupGuideModal.confluenceSpacesInfo"), "projects")), setupGuide.addedConfluenceSpaces ? /*#__PURE__*/React.createElement(StyledIcon, {
    src: "checkboxFill",
    color: "success",
    scale: 6
  }) : /*#__PURE__*/React.createElement(Icon, {
    src: "arrow",
    color: "textSecondary",
    scale: 6
  }))), setupGuide.addedLinearTeams !== undefined && /*#__PURE__*/React.createElement(Card, {
    s: {
      px: 6
    },
    onClick: () => window.open(`${RoutesEnum.INTEGRATIONS}`),
    color: "translucent",
    fullWidth: true
  }, /*#__PURE__*/React.createElement(Grid, {
    cols: 3,
    template: "1fr auto",
    align: "center",
    gap: 3
  }, /*#__PURE__*/React.createElement(Grid.Cell, null, /*#__PURE__*/React.createElement(Text, {
    element: "h3",
    s: {
      mr: 2
    }
  }, t("SetupGuideModal.linearTeams"), !setupGuide.addedLinearTeams && /*#__PURE__*/React.createElement(Text, {
    color: "textSecondary",
    fontSize: 3.5,
    s: {
      ml: 2
    },
    weight: "semiBold"
  }, t("SetupGuideModal.linearTeamsTime"))), !setupGuide.addedLinearTeams && /*#__PURE__*/React.createElement(Text, {
    color: "textSecondary"
  }, t("SetupGuideModal.linearTeamsInfo"))), setupGuide.addedLinearTeams ? /*#__PURE__*/React.createElement(StyledIcon, {
    src: "checkboxFill",
    color: "success",
    scale: 6
  }) : /*#__PURE__*/React.createElement(Icon, {
    src: "arrow",
    color: "textSecondary",
    scale: 6
  }))), setupGuide.addedAsanaProjects !== undefined && /*#__PURE__*/React.createElement(Card, {
    s: {
      px: 6
    },
    onClick: () => window.open(`${RoutesEnum.INTEGRATIONS}`),
    color: "translucent",
    fullWidth: true
  }, /*#__PURE__*/React.createElement(Grid, {
    cols: 3,
    template: "1fr auto",
    align: "center",
    gap: 3
  }, /*#__PURE__*/React.createElement(Grid.Cell, null, /*#__PURE__*/React.createElement(Text, {
    element: "h3",
    s: {
      mr: 2
    }
  }, t("SetupGuideModal.asanaProjects"), !setupGuide.addedAsanaProjects && /*#__PURE__*/React.createElement(Text, {
    color: "textSecondary",
    fontSize: 3.5,
    s: {
      ml: 2
    },
    weight: "semiBold"
  }, t("SetupGuideModal.asanaProjectsTime"))), !setupGuide.addedAsanaProjects && /*#__PURE__*/React.createElement(Text, {
    color: "textSecondary"
  }, t("SetupGuideModal.asanaProjectsInfo"))), setupGuide.addedAsanaProjects ? /*#__PURE__*/React.createElement(StyledIcon, {
    src: "checkboxFill",
    color: "success",
    scale: 6
  }) : /*#__PURE__*/React.createElement(Icon, {
    src: "arrow",
    color: "textSecondary",
    scale: 6
  }))), setupGuide.addedGithubRepositories !== undefined && /*#__PURE__*/React.createElement(Card, {
    s: {
      px: 6
    },
    onClick: () => window.open(`${RoutesEnum.INTEGRATIONS}`),
    color: "translucent",
    fullWidth: true
  }, /*#__PURE__*/React.createElement(Grid, {
    cols: 3,
    template: "1fr auto",
    align: "center",
    gap: 3
  }, /*#__PURE__*/React.createElement(Grid.Cell, null, /*#__PURE__*/React.createElement(Text, {
    element: "h3",
    s: {
      mr: 2
    }
  }, t("SetupGuideModal.githubRepositories"), !setupGuide.addedGithubRepositories && /*#__PURE__*/React.createElement(Text, {
    color: "textSecondary",
    fontSize: 3.5,
    s: {
      ml: 2
    },
    weight: "semiBold"
  }, t("SetupGuideModal.githubRepositoriesTime"))), !setupGuide.addedGithubRepositories && /*#__PURE__*/React.createElement(Text, {
    color: "textSecondary"
  }, t("SetupGuideModal.githubRepositoriesInfo"))), setupGuide.addedGithubRepositories ? /*#__PURE__*/React.createElement(StyledIcon, {
    src: "checkboxFill",
    color: "success",
    scale: 6
  }) : /*#__PURE__*/React.createElement(Icon, {
    src: "arrow",
    color: "textSecondary",
    scale: 6
  }))), setupGuide.addedProductboardProducts !== undefined && /*#__PURE__*/React.createElement(Card, {
    s: {
      px: 6
    },
    onClick: () => window.open(`${RoutesEnum.INTEGRATIONS}`),
    color: "translucent",
    fullWidth: true
  }, /*#__PURE__*/React.createElement(Grid, {
    cols: 3,
    template: "1fr auto",
    align: "center",
    gap: 3
  }, /*#__PURE__*/React.createElement(Grid.Cell, null, /*#__PURE__*/React.createElement(Text, {
    element: "h3",
    s: {
      mr: 2
    }
  }, t("SetupGuideModal.productboardProducts"), !setupGuide.addedProductboardProducts && /*#__PURE__*/React.createElement(Text, {
    color: "textSecondary",
    fontSize: 3.5,
    s: {
      ml: 2
    },
    weight: "semiBold"
  }, t("SetupGuideModal.productboardProductsTime"))), !setupGuide.addedProductboardProducts && /*#__PURE__*/React.createElement(Text, {
    color: "textSecondary"
  }, t("SetupGuideModal.productboardProductsInfo"))), setupGuide.addedProductboardProducts ? /*#__PURE__*/React.createElement(StyledIcon, {
    src: "checkboxFill",
    color: "success",
    scale: 6
  }) : /*#__PURE__*/React.createElement(Icon, {
    src: "arrow",
    color: "textSecondary",
    scale: 6
  }))), setupGuide.addedMondayBoards !== undefined && /*#__PURE__*/React.createElement(Card, {
    s: {
      px: 6
    },
    onClick: () => window.open(`${RoutesEnum.INTEGRATIONS}`),
    color: "translucent",
    fullWidth: true
  }, /*#__PURE__*/React.createElement(Grid, {
    cols: 3,
    template: "1fr auto",
    align: "center",
    gap: 3
  }, /*#__PURE__*/React.createElement(Grid.Cell, null, /*#__PURE__*/React.createElement(Text, {
    element: "h3",
    s: {
      mr: 2
    }
  }, t("SetupGuideModal.mondayBoards"), !setupGuide.addedMondayBoards && /*#__PURE__*/React.createElement(Text, {
    color: "textSecondary",
    fontSize: 3.5,
    s: {
      ml: 2
    },
    weight: "semiBold"
  }, t("SetupGuideModal.mondayBoardsTime"))), !setupGuide.addedMondayBoards && /*#__PURE__*/React.createElement(Text, {
    color: "textSecondary"
  }, t("SetupGuideModal.mondayBoardsInfo"))), setupGuide.addedMondayBoards ? /*#__PURE__*/React.createElement(StyledIcon, {
    src: "checkboxFill",
    color: "success",
    scale: 6
  }) : /*#__PURE__*/React.createElement(Icon, {
    src: "arrow",
    color: "textSecondary",
    scale: 6
  })))), (setupGuide.topicCreated !== undefined || setupGuide.topicReportSubscribed !== undefined) && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Text, {
    color: "primary",
    fontSize: 4,
    weight: "semiBold",
    s: {
      my: 2
    }
  }, /*#__PURE__*/React.createElement(Icon, {
    src: "interests",
    s: {
      mr: 2
    }
  }), t("SetupGuideModal.topics")), setupGuide.topicCreated !== undefined && /*#__PURE__*/React.createElement(Card, {
    s: {
      px: 6
    },
    onClick: () => window.open(`${RoutesEnum.TOPICS}`),
    color: "translucent",
    fullWidth: true
  }, /*#__PURE__*/React.createElement(Grid, {
    cols: 3,
    template: "1fr auto",
    align: "center",
    gap: 3
  }, /*#__PURE__*/React.createElement(Grid.Cell, null, /*#__PURE__*/React.createElement(Text, {
    element: "h3",
    s: {
      mr: 2
    }
  }, t("SetupGuideModal.createTopic"), !setupGuide.topicCreated && /*#__PURE__*/React.createElement(Text, {
    color: "textSecondary",
    fontSize: 3.5,
    s: {
      ml: 2
    },
    weight: "semiBold"
  }, t("SetupGuideModal.createTopicTime"))), !setupGuide.topicCreated && /*#__PURE__*/React.createElement(Text, {
    color: "textSecondary"
  }, t("SetupGuideModal.createTopicInfo"))), setupGuide.topicCreated ? /*#__PURE__*/React.createElement(StyledIcon, {
    src: "checkboxFill",
    color: "success",
    scale: 6
  }) : /*#__PURE__*/React.createElement(Icon, {
    src: "arrow",
    color: "textSecondary",
    scale: 6
  }))), setupGuide.topicReportSubscribed !== undefined && /*#__PURE__*/React.createElement(Card, {
    s: {
      px: 6
    },
    onClick: () => window.open(`${RoutesEnum.TOPICS}`),
    color: "translucent",
    fullWidth: true
  }, /*#__PURE__*/React.createElement(Grid, {
    cols: 3,
    template: "1fr auto",
    align: "center",
    gap: 3
  }, /*#__PURE__*/React.createElement(Grid.Cell, null, /*#__PURE__*/React.createElement(Text, {
    element: "h3",
    s: {
      mr: 2
    }
  }, t("SetupGuideModal.subscribeTopicReport"), !setupGuide.topicReportSubscribed && /*#__PURE__*/React.createElement(Text, {
    color: "textSecondary",
    fontSize: 3.5,
    s: {
      ml: 2
    },
    weight: "semiBold"
  }, t("SetupGuideModal.subscribeTopicReportTime"))), !setupGuide.topicReportSubscribed && /*#__PURE__*/React.createElement(Text, {
    color: "textSecondary"
  }, t("SetupGuideModal.subscribeTopicReportInfo"))), setupGuide.topicReportSubscribed ? /*#__PURE__*/React.createElement(StyledIcon, {
    src: "checkboxFill",
    color: "success",
    scale: 6
  }) : /*#__PURE__*/React.createElement(Icon, {
    src: "arrow",
    color: "textSecondary",
    scale: 6
  })))), setupGuide.insightsReportCreated !== undefined && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Text, {
    color: "primary",
    fontSize: 4,
    weight: "semiBold",
    s: {
      my: 2
    }
  }, /*#__PURE__*/React.createElement(Icon, {
    src: "troubleshoot",
    s: {
      mr: 2
    }
  }), t("SetupGuideModal.insights")), /*#__PURE__*/React.createElement(Card, {
    s: {
      px: 6
    },
    onClick: () => window.open(`${RoutesEnum.INSIGHTS_EXPLORER}`),
    color: "translucent",
    fullWidth: true
  }, /*#__PURE__*/React.createElement(Grid, {
    cols: 3,
    template: "1fr auto",
    align: "center",
    gap: 3
  }, /*#__PURE__*/React.createElement(Grid.Cell, null, /*#__PURE__*/React.createElement(Text, {
    element: "h3",
    s: {
      mr: 2
    }
  }, t("SetupGuideModal.scheduleInsights"), !setupGuide.insightsReportCreated && /*#__PURE__*/React.createElement(Text, {
    color: "textSecondary",
    fontSize: 3.5,
    s: {
      ml: 2
    },
    weight: "semiBold"
  }, t("SetupGuideModal.scheduleInsightsTime"))), !setupGuide.topicReportSubscribed && /*#__PURE__*/React.createElement(Text, {
    color: "textSecondary"
  }, t("SetupGuideModal.scheduleInsightsInfo"))), setupGuide.insightsReportCreated ? /*#__PURE__*/React.createElement(StyledIcon, {
    src: "checkboxFill",
    color: "success",
    scale: 6
  }) : /*#__PURE__*/React.createElement(Icon, {
    src: "arrow",
    color: "textSecondary",
    scale: 6
  })))), setupGuide.membersInvited !== undefined && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Text, {
    color: "primary",
    fontSize: 4,
    weight: "semiBold",
    s: {
      my: 2
    }
  }, /*#__PURE__*/React.createElement(Icon, {
    src: "people",
    s: {
      mr: 2
    }
  }), t("SetupGuideModal.members")), /*#__PURE__*/React.createElement(Card, {
    s: {
      px: 6
    },
    onClick: () => window.open(`${RoutesEnum.INVITATIONS}`),
    color: "translucent",
    fullWidth: true
  }, /*#__PURE__*/React.createElement(Grid, {
    cols: 3,
    template: "1fr auto",
    align: "center",
    gap: 3
  }, /*#__PURE__*/React.createElement(Grid.Cell, null, /*#__PURE__*/React.createElement(Text, {
    element: "h3",
    s: {
      mr: 2
    }
  }, t("SetupGuideModal.sendInvitations"), !setupGuide.membersInvited && /*#__PURE__*/React.createElement(Text, {
    color: "textSecondary",
    fontSize: 3.5,
    s: {
      ml: 2
    },
    weight: "semiBold"
  }, t("SetupGuideModal.sendInvitationsTime"))), !setupGuide.membersInvited && /*#__PURE__*/React.createElement(Text, {
    color: "textSecondary"
  }, t("SetupGuideModal.sendInvitationsInfo"))), /*#__PURE__*/React.createElement(Box, {
    gap: 3
  }, /*#__PURE__*/React.createElement(Badge, {
    color: "translucent"
  }, t("SetupGuideModal.optional")), setupGuide.membersInvited ? /*#__PURE__*/React.createElement(StyledIcon, {
    src: "checkboxFill",
    color: "success",
    scale: 6
  }) : /*#__PURE__*/React.createElement(Icon, {
    src: "arrow",
    color: "textSecondary",
    scale: 6
  }))))))), /*#__PURE__*/React.createElement(Modal.Actions, null, /*#__PURE__*/React.createElement(Button, {
    color: "translucent",
    s: {
      px: 8
    },
    onClick: onClose,
    rounded: true,
    display: "inline-block"
  }, t("common.actions.close"))));
};
export default SetupGuideModal;